import { render, staticRenderFns } from "./quarantineDetail.vue?vue&type=template&id=225e37db&scoped=true&"
import script from "./quarantineDetail.vue?vue&type=script&lang=js&"
export * from "./quarantineDetail.vue?vue&type=script&lang=js&"
import style0 from "./quarantineDetail.vue?vue&type=style&index=0&id=225e37db&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "225e37db",
  null
  
)

export default component.exports